import Layout from "@/components/Layout";
import PageHead from "@/components/PageHead";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [valid, setValid] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes("type=recovery")) {
      setValid(true);
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      toast.success("Password updated successfully");
      navigate("/client-portal");
    } catch (err: any) {
      toast.error('An error occurred. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout>
      <PageHead title="Reset Password" description="Set a new password for your Batts Legal LLP account." path="/reset-password" />
      <section className="section-padding">
        <div className="editorial-container max-w-md">
          <div className="bg-card rounded-lg p-10 shadow-elevated border border-border">
            <h1 className="font-serif text-2xl font-semibold text-foreground mb-6 text-center">Set New Password</h1>
            {valid ? (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-foreground block mb-2">New Password</label>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)} required minLength={6} className="w-full border border-border rounded-sm px-4 py-2.5 text-sm bg-background text-foreground" />
                </div>
                <button type="submit" disabled={submitting} className="w-full bg-primary text-primary-foreground py-3 rounded-sm font-medium text-sm hover:opacity-90 transition-opacity disabled:opacity-50">
                  {submitting ? "Updating..." : "Update Password"}
                </button>
              </form>
            ) : (
              <p className="text-sm text-muted-foreground text-center">Invalid or expired reset link. Please request a new password reset.</p>
            )}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ResetPassword;
